import { RootState } from "../store";
import { RX_EVENT_TYPES, RxEvent, RxEventType, RxSeries, RxSeriesType } from "./rx-diag-types";

export function selectAvailableSeriesTypes({ rxdiag }: RootState): RxSeriesType[] {
  const { selectedFiles, dataListByFile } = rxdiag;
  const availableTypes = new Set<RxSeriesType>();

  for (const filename of selectedFiles) {
    const dataList = dataListByFile[filename];
    if (dataList?.status !== "loaded") continue;

    for (const seriesType of dataList.seriesTypes) {
      availableTypes.add(seriesType);
    }
  }

  return [...availableTypes];
}

// Note: This selector returns both standard event types if any selected file has events available.
// This is because we don't know which event types are available per file until we load them.
// For better support the backend would need to provide event type availability per file.
export function selectAvailableEventTypes({ rxdiag }: RootState): RxEventType[] {
  const { selectedFiles, dataListByFile } = rxdiag;
  for (const filename of selectedFiles) {
    const dataList = dataListByFile[filename];
    if (dataList?.status !== "loaded") continue;
    if (dataList.eventsAvailable) return [...RX_EVENT_TYPES];
  }
  return [];
}

export function selectDisplayedSeries({ user, rxdiag }: RootState): RxSeries[] {
  const { selectedFiles, selectedSeriesTypes, seriesData } = rxdiag;
  const displayedSeries: RxSeries[] = [];
  for (const sd of seriesData) {
    if (
      sd.status === "loaded" &&
      selectedFiles.includes(sd.filename) &&
      selectedSeriesTypes.includes(sd.type) &&
      sd.timeC == user.useTimeCorrection
    ) {
      displayedSeries.push(sd.series);
    }
  }
  return displayedSeries;
}

export function selectDisplayedEvents({ user, rxdiag }: RootState): RxEvent[] {
  const { selectedFiles, selectedEventTypes, eventsData } = rxdiag;
  const displayedEvents: RxEvent[] = [];

  for (const ed of eventsData) {
    if (
      ed.status === "loaded" &&
      selectedFiles.includes(ed.filename) &&
      ed.timeC == user.useTimeCorrection
    ) {
      displayedEvents.push(...ed.events.filter(event => selectedEventTypes.includes(event.type)));
    }
  }

  return displayedEvents;
}
